import { render, Suspense } from '@wordpress/element';
import Block from './components/Block';

window.addEventListener( 'DOMContentLoaded', () => {
	const element = document.querySelector( '#sci-bcl-comercio-app' );
	if ( element ) {
		// Recogemos los atributos (data-*) del bloque.
		const attributes = { ...element.dataset };

		// Parseamos los valores que vienen como string.
		if ( attributes.maxBonosComercio ) {
			attributes.maxBonosComercio = parseInt(
				attributes.maxBonosComercio,
				10
			);
		}
		if ( attributes.remainingBonos ) {
			attributes.remainingBonos = parseInt(
				attributes.remainingBonos,
				10
			);
		}
		if ( attributes.progresoConvocatoria ) {
			attributes.progresoConvocatoria = parseFloat(
				attributes.progresoConvocatoria
			);
		}

		render(
			<Suspense fallback={ <div className="wp-block-placeholder" /> }>
				<Block { ...attributes } />
			</Suspense>,
			element
		);
	}
} );
